module.exports = __webpack_public_path__ + "img/NiCE_Mpower_logo.87160826.png";